<template>
  <div class="datagrid-item">
    <div class="datagrid-title">Купон</div>
    <div class="datagrid-content mt-1"><b>{{ getVal() }}</b></div>
  </div>
</template>

<script>
import {defineComponent} from "vue"

export default defineComponent({
  name: "Coupon",
  props: {
    data: {
      type: String,
      require: true,
    },
  },
  setup(props) {
    function getVal() {
      if (props.data["coupon"] === "" || props.data["coupon"] === null) {
        return "Пусто"
      }

      return props.data["coupon"]
    }

    return {
      getVal,
    }
  }
})
</script>

<style scoped>

</style>
